import { useGetChatBadgeCount } from '@/api/user-dashboard/queries';
import { useSelectedUserConfigSlice } from '@/stores/selectors';
import { getContextChatUnreadCount } from '@/utils/get-context-chat-unread-count';

export const useCommunicationsUnreadCount = (): number => {
  const { selectedUserRole, selectedEntityId } = useSelectedUserConfigSlice();
  const { data } = useGetChatBadgeCount();

  return getContextChatUnreadCount(data, selectedUserRole, selectedEntityId);
};
